const typeIntermediary = {
  noBranchOfficeColones:
    'Selecciona la opción a comprar, podrás realizar la compra de la póliza con tu tarjeta débito o crédito, por transferencia bancaria o SINPE Móvil.',
  noBranchOfficeDollars:
    'Selecciona la opción a comprar, podrás realizar la compra de la póliza con tu tarjeta débito o crédito o por transferencia bancaria.',
  withBranchOffice:
    'Selecciona la opción a comprar, podrás realizar la compra de la póliza con tu tarjeta débito o crédito.',
};

export const typeOfMoney = {
  colones: '₡',
  dollars: '$',
};

export default typeIntermediary;
